module.exports = __webpack_public_path__ + "static/media/Snake Charmer.7caf60cc.jpg";